import axios from 'axios';
import { browserHistory } from 'react-router';
import { SubmissionError } from 'redux-form'

import {
  REQUEST_WHOLESALE,
  FETCH_WHOLESALE_SUCCESS,
  FETCH_WHOLESALE_FAILURE,
  SELECT_WHOLESALE,
  RESET_CURRENT_WHOLESALE,
  REQUEST_WHOLESALE_DETAIL,
  FETCH_WHOLESALE_DETAIL_SUCCESS,
  FETCH_WHOLESALE_DETAIL_FAILURE,
  REQUEST_CREATING_WHOLESALE,
  CREATE_WHOLESALE_SUCCESS,
  CREATE_WHOLESALE_FAILURE,
  REQUEST_EDITING_WHOLESALE,
  EDIT_WHOLESALE_SUCCESS,
  EDIT_WHOLESALE_FAILURE
} from './type'

import {
    WHOLESALE_URL,
    SALES_ORDERS_URL
} from './url';

import { DEFAULT_ERROR } from '../components/Common/constants';
import {isGGI} from './root_url'

export function fetchWholesale() {
    return dispatch => {
        dispatch(requestWholesale());
        return axios.get(WHOLESALE_URL,
            {
                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
            }
        )
            .then(response => {
              dispatch(fetchWholesaleSuccess(response));
            }, err => {
              if (err.status === 500 || err.status === 404) {
                err.data = DEFAULT_ERROR;
              }
              if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
                document.getElementById('tokenInvalid').style.display = 'flex'
              } else {
                dispatch(fetchWholesaleFailure(err));                             
              }
            });
    }
}

export function requestWholesale() {
    return {
        type: REQUEST_WHOLESALE,
    };
}

export function fetchWholesaleSuccess(wholesale) {
    return {
        type: FETCH_WHOLESALE_SUCCESS,
        payload: wholesale
    };
}

export function fetchWholesaleFailure(error) {
    return {
        type: FETCH_WHOLESALE_FAILURE,
        payload: error
    };
}


export function selectWholesale(wholesale) {
    return {
        type: SELECT_WHOLESALE,
        payload: wholesale
    };
}


export function resetCurrentWholesale() {
    return {
        type: RESET_CURRENT_WHOLESALE
    }
}

// Fetch the detail page.

export function fetchWholesaleOrderDetail(wholesale_id) {
    return dispatch => {
        dispatch(requestWholesaleDetail());
        return axios.get(SALES_ORDERS_URL + wholesale_id,
            {
                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
            }
        )
            .then(response => {
              dispatch(fetchWholesaleDetailSuccess(response));
            }, err => {
              if (err.status === 500 || err.status === 404) {
                err.data = DEFAULT_ERROR;
              }
              if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
                document.getElementById('tokenInvalid').style.display = 'flex'
              } else {
                dispatch(fetchWholesaleDetailFailure(err));                             
              }
            });
    }
}

export function requestWholesaleDetail() {
    return {
        type: REQUEST_WHOLESALE_DETAIL,
    };
}

export function fetchWholesaleDetailSuccess(wholesaleDetail) {
    wholesaleDetail = wholesaleDetail.data;
    // The date data fetched is in the form of string, which needs to be modified into Date type
    if (wholesaleDetail.OrderDate) wholesaleDetail.OrderDate = new Date(wholesaleDetail.OrderDate);
    if (wholesaleDetail.ETADate) wholesaleDetail.ETADate = new Date(wholesaleDetail.ETADate);
    if (wholesaleDetail.ReceivedDate) wholesaleDetail.ReceivedDate = new Date(wholesaleDetail.ReceivedDate);
    return {
        type: FETCH_WHOLESALE_DETAIL_SUCCESS,
        payload: wholesaleDetail
    };
}

export function fetchWholesaleDetailFailure(error) {
    return {
        type: FETCH_WHOLESALE_DETAIL_FAILURE,
        payload: error
    };
}

export function createWholesale({
    Sales_Order_Line,
    OrderDate,
    ETADate,
    ReceivedDate,
    FinalNetWeight,
    FinalShippingWeight,
    TotalPrice,
    NoteToVendor,
    ReleaseInformation,
    CarryType,
    Discount,
    ShippingCost,
    HandlingCost,
    SalesStatus,
    MiscCost,
    MiscNote,
    TaxRate,
    PaymentStatus,
    FinalPrice,
    ConvertItemPrice,
    Vendor_id,
    Pickup_VendorAddress_id,
    Pickup_VendorContact_id,
    Deliver_Warehouse_id,
    DispatchMethod_id,
    DispatchOutSourceContact_id,
    Sales_User_id,
    Modifier_User_id
}) {
    Sales_Order_Line.map(
        product => {
            if (product.Product_id)
                product.Product_id = product.Product_id.value || product.Product_id;
        }
    )
    if (Vendor_id) Vendor_id = Vendor_id.value || Vendor_id;
    if (Pickup_VendorAddress_id) Pickup_VendorAddress_id = Pickup_VendorAddress_id.value || Pickup_VendorAddress_id;
    if (Pickup_VendorContact_id) Pickup_VendorContact_id = Pickup_VendorContact_id.value || Pickup_VendorContact_id;
    return dispatch => {
        dispatch({ type: REQUEST_CREATING_WHOLESALE });
        axios.post(WHOLESALES_URL,
            {
                Sales_Order_Line,
                OrderDate,
                ETADate,
                ReceivedDate,
                FinalNetWeight,
                FinalShippingWeight,
                TotalPrice,
                NoteToVendor,
                ReleaseInformation,
                CarryType,
                Discount,
                ShippingCost,
                HandlingCost,
                MiscCost,
                MiscNote,
                TaxRate,
                SalesStatus,
                PaymentStatus,
                FinalPrice,
                ConvertItemPrice,
                Vendor_id,
                Pickup_VendorAddress_id,
                Pickup_VendorContact_id,
                Deliver_Warehouse_id,
                DispatchMethod_id,
                DispatchOutSourceContact_id,
                Sales_User_id,
                Modifier_User_id
            },
            {
                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
            }
        )
            .then(response => {
              dispatch(createWholesaleSuccess());
              browserHistory.push('/wholesale');
            }, err => {
              if (err.status === 500 || err.status === 404) {
                err.data = DEFAULT_ERROR;
              }
              if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
                document.getElementById('tokenInvalid').style.display = 'flex'
              } else {
                dispatch(createWholesaleFailure(err));                             
              }
            });
    }
}

export function createWholesaleSuccess() {
    return {
        type: CREATE_WHOLESALE_SUCCESS
    }
}

export function createWholesaleFailure(error) {
    return {
        type: CREATE_WHOLESALE_FAILURE,
        payload: error
    }
}

export function editWholesale({
    Wholesale_id,
    Sales_Order_Line,
    ETADate
}) {
    Sales_Order_Line.map(
        product => {
            if (product.Product_id)
                product.Product_id = product.Product_id.value || product.Product_id;
        }
    )
    return dispatch => {
        dispatch({ type: REQUEST_EDITING_WHOLESALE });
        axios.put((WHOLESALES_URL + Wholesale_id),
            {
                Sales_Order_Line,
                ETADate
            },
            {
                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
            }
        )
            .then(response => {
              dispatch(editWholesaleSuccess());
              browserHistory.push('/salesOrder'); // If editd succesfully, refresh the paymentTerm page.
            }, err => {
              if (err.status === 500 || err.status === 404) {
                err.data = DEFAULT_ERROR;
              }
              if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
                document.getElementById('tokenInvalid').style.display = 'flex'
              } else {
                dispatch(editWholesaleFailure(err));                             
              }
            });
    }
}

export function editWholesaleSuccess() {
    return {
        type: EDIT_WHOLESALE_SUCCESS
    }
}

export function editWholesaleFailure(error) {
    return {
        type: EDIT_WHOLESALE_FAILURE,
        payload: error
    }
}



// WEBPACK FOOTER //
// ./master/jsx/actions/wholesale_actions.jsx